import { Component } from '@theme/component'
import { QuantitySelectorUpdateEvent } from '@theme/events'

class QuantitySelectorComponent extends Component {
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    this.quantityInput.stepUp()
    this.#onQuantityChange()
  }

  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    this.quantityInput.stepDown()
    this.#onQuantityChange()
  }

  selectInputValue(event) {
    if (
      !(event.target instanceof HTMLInputElement) ||
      document.activeElement !== this.quantityInput
    )
      return

    this.quantityInput.select()
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    if (event.target instanceof HTMLInputElement) {
      this.quantityInput.value = event.target.value
    }
    this.#onQuantityChange()
  }

  #onQuantityChange() {
    this.#checkQuantityRules()
    const newValue = Number.parseInt(this.quantityInput.value, 10)

    this.quantityInput.dispatchEvent(
      new QuantitySelectorUpdateEvent(
        newValue,
        Number(this.quantityInput.dataset.cartLine)
      )
    )
  }

  #checkQuantityRules = () => {
    const newValue = Number(this.quantityInput.value)
    const min = Number(this.quantityInput.min)
    const max = Number(this.quantityInput.max)

    if (this.quantityInput.min && newValue < min) {
      this.quantityInput.value = this.quantityInput.min
    }

    if (this.quantityInput.max && newValue > max) {
      this.quantityInput.value = this.quantityInput.max
    }
  }

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error(
        'Missing <input ref="quantityInput" /> inside <quantity-selector />'
      )
    }

    return this.refs.quantityInput
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelectorComponent)
}
